import React, { useContext } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { FaBalanceScale, FaBriefcase, FaCog, FaFolderOpen, FaHome, FaPlusCircle, FaUserCheck } from 'react-icons/fa';
import { AuthContext } from '../context/AuthContext';
import '../styles/AppLayout.css';

export default function AppLayout({ children }) {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const displayName = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || user?.email;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="app-shell">
      <nav className="navbar">
        <div className="navbar-brand">
          <Link to="/dashboard" className="brand-link">
            <span className="brand-mark">
              <FaBalanceScale />
            </span>
            <span>
              <strong>Libra Legal</strong>
              <small>Case Intelligence</small>
            </span>
          </Link>
        </div>
        <div className="navbar-menu">
          <span>Welcome, <strong>{displayName}</strong></span>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </nav>

      <div className="app-body">
        <aside className="sidebar">
          <ul className="nav-list">
            <li>
              <NavLink to="/dashboard" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                <FaHome />
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/create-case" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                <FaPlusCircle />
                <span>Create Case</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/cases" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                <FaFolderOpen />
                <span>My Cases</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/human-verification" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                <FaUserCheck />
                <span>Verification Workbench</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/settings" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                <FaCog />
                <span>Settings</span>
              </NavLink>
            </li>
          </ul>
          <div className="sidebar-footer">
            <FaBriefcase />
            <span>POC Workspace</span>
          </div>
        </aside>

        <main className="app-main">
          {children}
        </main>
      </div>
    </div>
  );
}
